module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "article-links"
  }, [(!_vm.$store.state.isEnhanced && _vm.article.abstract) ? _c('li', {
    staticClass: "article-link-item hidden-sm-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleAbstract()
      }
    }
  }, [_vm._v("Abstract")])]) : _vm._e(), _vm._v(" "), (_vm.article && _vm.article.files.pdf && _vm.article.files.pdf.display) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.article.files.pdf.url
    }
  }, [_vm._v("PDF")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isEnhanced) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setEnhancedView(false, {
          name: 'article-detail',
          params: {
            pii: _vm.article.ids.pii
          }
        })
      }
    }
  }, [_vm._v("Full text")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isEnhanced) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setEnhancedView(true, {
          name: 'article-detail',
          params: {
            pii: _vm.article.ids.pii
          }
        })
      }
    }
  }, [_vm._v("Enhanced View")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isEnhanced) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setEnhancedView(false, {
          name: 'article-detail',
          params: {
            pii: _vm.article.ids.pii
          }
        })
      }
    }
  }, [_vm._v("Traditional View")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "article-link-item hidden-sm-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$root.$emit('show::modal', 'orderReprintModal', _vm.article)
      }
    }
  }, [_vm._v("Order a Reprint")])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', [_vm._v("How to Cite")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "article-link-item hidden-sm-down"
  }, [_c('a', [_vm._v("Related Articles")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25bf06ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ArticleQuickLinksComponent.vue
// module id = 1405
// module chunks = 1